import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Image from "@default/general-components/image/image";
import { useSliderContext } from "@default/general-components/slider/context";

const Multimedia = ({ content, slideIndex }) => {
  const videoRef = useRef(null);
  const { selectedIndex, emblaApi, setSlideDuration } =
    useSliderContext() || {};

  useEffect(() => {
    const video = videoRef.current;
    if (!video || selectedIndex === undefined) return;

    if (selectedIndex === slideIndex) {
      video.currentTime = 0;
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }, [selectedIndex, slideIndex]);

  if (!content) return null;

  switch (content.entityBundle) {
    case "video":
      return content.mediaFileUrl?.path ? (
        <video
          ref={videoRef}
          src={content.mediaFileUrl.path}
          muted
          playsInline
          preload="auto"
          aria-hidden="true"
          tabIndex={-1}
          onLoadedMetadata={(e) =>
            setSlideDuration?.(slideIndex, e.target.duration * 1000)
          }
          onEnded={() => emblaApi?.scrollNext()}
        />
      ) : null;

    case "image":
      return content.fieldMediaImage ? (
        <Image data={content.fieldMediaImage} />
      ) : null;

    default:
      return null;
  }
};

Multimedia.propTypes = {
  content: PropTypes.shape({
    entityBundle: PropTypes.string.isRequired,
    mediaFileUrl: PropTypes.shape({
      path: PropTypes.string,
    }),
    fieldMediaImage: PropTypes.object,
    fieldCaption: PropTypes.string,
    fieldCredits: PropTypes.string,
  }),
  slideIndex: PropTypes.number.isRequired,
};

export default Multimedia;
